/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ca-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "accuroEndpoints",
            "endpoint": "https://jb579jvyma.execute-api.ca-central-1.amazonaws.com/production",
            "region": "ca-central-1"
        },
        {
            "name": "featureFlagsAPI",
            "endpoint": "https://fuvagyobfk.execute-api.ca-central-1.amazonaws.com/production",
            "region": "ca-central-1"
        },
        {
            "name": "messagesAPI",
            "endpoint": "https://4bef4sfsuf.execute-api.ca-central-1.amazonaws.com/production",
            "region": "ca-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "ca-central-1:d227524d-33cf-444b-842b-76257cbb9a71",
    "aws_cognito_region": "ca-central-1",
    "aws_user_pools_id": "ca-central-1_62PbZ5tMf",
    "aws_user_pools_web_client_id": "1629p4idqgri361ht7bcndilom",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
